/**
 * Pop-up functions for social sharing buttons
 */

const shareLinks = document.querySelectorAll(".social-sharing a");
shareLinks.forEach((link) => {
    link.addEventListener("click", function (event) {
        event.preventDefault();
        const href = event.target.getAttribute("href");
        const network = event.target.getAttribute("data-network");

        const networks = {
            facebook: {width: 600, height: 566},
            twitter: {width: 600, height: 374},
            linkedin: {width: 600, height: 400},
        };

        let popup = function (network) {
            var options = "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,";
            window.open(href, "", options + "height=" + networks[network].height + ",width=" + networks[network].width);
        };

        popup(network);
        this.blur();
    });
});

/**
 * Open external links in new window
 */
[...document.links].forEach((link) => {
    if (link.hostname != window.location.hostname) {
        link.target = "_blank";
    }
});

/**
 * Disabled links
 */
const links = document.querySelectorAll("a.disabled");
const listLinks = document.querySelectorAll("li.disabled > a");
const disableLinks = (el) => {
    el.addEventListener("click", (e) => {
        e.preventDefault();
        el.href = "";
        el.setAttribute("aria-disabled", "true");
    });
};
links.forEach(disableLinks);
listLinks.forEach(disableLinks);

/**
 * Showhide plugin shortcode override
 */
let showHides = document.querySelectorAll(".sllc-showhideshortcode-content");
showHides.forEach((el) => {
    let btn = el.querySelector(".sllc-ssc-button");
    let ariaExpanded = btn.getAttribute("aria-expanded") === "true";
    btn.addEventListener("click", (e) => {
        ariaExpanded = !ariaExpanded;
        e.preventDefault();
        el.querySelector(".sllc-ssc-body").classList.toggle("hidden");
        btn.setAttribute("aria-expanded", ariaExpanded);
        if (ariaExpanded) {
            btn.textContent = btn.dataset.hideCaption;
        } else {
            btn.textContent = btn.dataset.showCaption;
        }
    });
});

/**
 * Proper offsetTop implementation
 * https://medium.com/@alexcambose/js-offsettop-property-is-not-great-and-here-is-why-b79842ef7582
 */
const getOffsetTop = (element) => {
    let offsetTop = 0;
    while (element) {
        offsetTop += element.offsetTop;
        element = element.offsetParent;
    }
    return offsetTop;
};

/**
 * Floating Contact Form scripts
 */
const fcfTrigger = document.querySelector("#floating-contact-form-trigger");
const fcf = document.querySelector("#floating-contact-form");

if (fcfTrigger && fcf) {
    const fcfClose = document.createElement("button");
    const origBtnText = fcfTrigger.textContent;
    const hideFcf = () => {
        if (!fcf.classList.contains("hidden")) {
            fcf.classList.add("hidden");
            fcfTrigger.textContent = origBtnText;
        }
    };

    fcfClose.setAttribute("class", "floating-contact-form-close");
    fcfClose.setAttribute("role", "button");
    fcfClose.textContent = "✖";
    fcf.appendChild(fcfClose);

    fcfTrigger.onclick = (ev) => {
        ev.preventDefault();
        ev.stopPropagation();
        if (fcf.classList.contains("hidden")) {
            fcf.classList.remove("hidden");
            fcfTrigger.textContent = "Close";
        } else {
            hideFcf();
        }
    };
    fcf.onclick = (ev) => {
        ev.stopPropagation();
    };
    fcfClose.onclick = (ev) => {
        ev.stopPropagation();
        hideFcf();
    };

    /**
     * Escape function - to hide back popups
     * Global click function - to hide
     */
    document.addEventListener("keydown", (ev) => {
        if (ev.key === "Escape") {
            hideFcf();
        }
    });
    document.addEventListener("click", (ev) => {
        hideFcf();
    });
}
